







































    import { Component, Vue } from "vue-property-decorator";
    import { getNewsList } from '@/api/news.js';

	@Component
	export default class News extends Vue {
        private pageNum: any = 1;
        private total: any = 0;
        private pastList: any = [];
        private curList: any = [];

        private jump() {
            this.$router.push({
                path: `/news/${this.newsTop.news_id}`
            });
        }
        
        private get newsTop() {
            return this.$store.state.common.newsTop;
        }

        private getDay(date: any) {
            const arr = (date || '').split('-');

            return arr[2] + '/' + arr[1];
        }

        private getYear(date: any) {
            return (date || '').split('-')[0]; 
        }

        private handleClick(item: any) {
            this.$router.push({
                path: `/news/${item.news_id}`
            });
        }

        private async getNewsDataList() {
            const { code, data: { count, list }, message } = await getNewsList({ page: this.pageNum });

            if (code == 0) {
                this.total = count;
                this.curList = list;
                this.pastList = [].concat(this.pastList.slice(0), list);
            } else {
                console.log(message);
            }
        }

        private viewMore() {
            this.getNewsDataList();
            this.pageNum ++;
        }

        private mounted() {
            this.getNewsDataList();
            this.pageNum ++;
        }
	}
